import { defineMessages } from 'react-intl-next';

const _default_1: {
    hubLoadingSpinnerLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
    hubLoadingSpinnerLabel: {
        id: 'company-hub.hub.loading-spinner-label',
        defaultMessage: 'Loading hub',
        description: 'Label for the hub loading spinner',
    },
});
export default _default_1;
